import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { X, Megaphone } from "lucide-react";

// Yellow bar on top of the dashboard for super-admin broadcasts; dismissed per user.
export default function AnnouncementBar() {
  const [items, setItems] = useState([]);
  const auth = { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } };
  useEffect(() => {
    axios.get(`${API}/announcements/active`, auth).then((r) => setItems(r.data.announcements || [])).catch(() => {});
  }, []);
  const dismiss = (id) => { setItems((a) => a.filter((x) => x.id !== id)); axios.post(`${API}/announcements/${id}/dismiss`, {}, auth).catch(() => {}); };
  if (!items.length) return null;
  const a = items[0];
  const sameOrigin = a.link && a.link.startsWith("https://chatity.io");
  const href = sameOrigin ? a.link.replace("https://chatity.io", "") : a.link;
  return (
    <div className="bg-amber-300 border-b-2 border-black text-black w-full" data-testid="announcement-bar">
      <div className="container mx-auto px-3 md:px-4 py-2.5 flex items-start gap-3">
        <Megaphone size={18} className="mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0 text-sm">
          <span className="font-bold">{a.title}</span>
          <span className="block text-xs md:text-sm whitespace-pre-line line-clamp-3">{a.text}</span>
        </div>
        {a.link && (
          <a href={href} className="shrink-0 bg-black text-white text-xs md:text-sm font-bold px-3 py-1.5 rounded-lg hover:opacity-80" data-testid="announcement-link">
            {a.link_label || "→"}
          </a>
        )}
        <button type="button" onClick={() => dismiss(a.id)} className="shrink-0 p-1 rounded hover:bg-amber-400" aria-label="Close" data-testid="announcement-dismiss"><X size={16} /></button>
      </div>
    </div>
  );
}
